///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ActiveRestorableWindow } from './active-restorable-window';
import { ElementRef } from '@angular/core';
import { CdkDragEnd } from '@angular/cdk/drag-drop';

export abstract class AbstractInteractiveWindow extends ActiveRestorableWindow {
    private offsetLeft;
    private offsetTop;

    constructor(private readonly windowElement: ElementRef) {
        super();
    }

    setOffsets(offsetTop: number, offsetLeft: number): void {
        this.offsetTop = offsetTop;
        this.offsetLeft = offsetLeft;
    }

    dragEnded(event: CdkDragEnd): void {
        this.offsetLeft += event.distance.x;
        this.offsetTop += event.distance.y;
    }

    getBbox(): number[] {
        const parentDiv = this.windowElement.nativeElement.parentElement;

        const clientHeight = parentDiv.clientHeight;
        const clientWidth = parentDiv.clientWidth;

        return [
            clientHeight / window.innerHeight,
            clientWidth / window.innerWidth,
            this.offsetLeft / window.innerWidth,
            this.offsetTop / window.innerHeight
        ];
    }

    isCanBeClosed(): boolean {
        return true;
    }

    nodeCreate(_nodeName: string, _isEnabled: boolean): void {
        //     by default do nothing
    }

    nodeDelete(_nodeName: string): void {
        //     by default do nothing
    }

    nodeEnabled(_name: string, _enabled: boolean): void {
        //     by default do nothing
    }

    nodeSelected(_name: string, _selected: boolean): void {
        //     by default do nothing
    }

    nodeNameChanged(_oldName: string, _newName: string): void {
        //     by default do nothing
    }

    nodeLayerChanged(_name: string, _newLayerId: number): void {
        //     by default do nothing
    }

    linkCreate(_fromNode: string, _toNode: string, _isDisabled: boolean): void {
        //     by default do nothing
    }

    linkDelete(_fromNode: string, _toNode: string): void {
        //     by default do nothing
    }

    linkDisabled(_fromNode: string, _toNode: string, _value: boolean): void {
        //     by default do nothing
    }

    linkFrozen(_fromName: string, _toName: string, _isForced: boolean): void {
        //     by default do nothing
    }

    linkInstalled(_fromName: string, _toName: string, _isInstalled: boolean): void {
        //     by default do nothing
    }

    linkSelected(_fromName: string, _toName: string, _selected: boolean): void {
        //     by default do nothing
    }

    sectorDirection(_aggregatedSectorIndex: number, _angle: number): void {
        //     by default do nothing
    }

    sectorSelected(_aggregatedSectorIndex: number, _selected: boolean): void {
        //     by default do nothing
    }
}
